import React, { useState, useEffect } from "react";
// import { connect } from "react-redux";
import { Link } from "react-router-dom";
// import constants from "../../../constants";
import { format } from "date-fns";
import { useSelector } from "react-redux";

import TableDropdownAndPagination from "../../../services/TableDropdownAndPagination";
import {
  concateAddress,
  convertToOriginalForm,
  viewGlobalMapURL,
} from "../../../services/StringOperation";
import ExportButtons from "../SkeletonLoader/ExportButtons";
import TableNewPaginanation from "../../../services/TableNewPaginanation";
import MapModal from "../Map/MapModal";
import { FaMapMarkerAlt } from "react-icons/fa";

const MyAssignmentsList = ({
  assignmentTypeParam,
  myAssignmentsDetails,
  ...props
}) => {
  const [myassignments, SetMyAssignments] = useState([]);
  const [recordLen, setRecordLen] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [dataLen, setDataLen] = useState(0);
  const [setFilter] = useState("");
   const [selectedDestination, setSelectedDestination] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [originAddress, setOriginAddress] = useState("");

  
  let totalPages = Math.ceil(dataLen / recordsPerPage);
  let startIndex = (currentPage - 1) * recordsPerPage;
  let endIndex = Math.min(startIndex + recordsPerPage, dataLen);
  let checkData = false;
  useEffect(() => {
    const filterAssignments = myAssignmentsDetails.filter(
      (assign) =>
        assign.cnd_assignment_status ===
        (assignmentTypeParam ? assignmentTypeParam : "Assigned")
    );
    const lenOfData = myAssignmentsDetails.length;
    // console.log("lenOfData", assignmentTypeParam);
    setDataLen(lenOfData);
    totalPages = Math.ceil(lenOfData / recordsPerPage);
    startIndex = (currentPage - 1) * recordsPerPage;
    endIndex = Math.min(startIndex + recordsPerPage, lenOfData);
    SetMyAssignments(filterAssignments);
  }, [myAssignmentsDetails]);

  const handleLeft = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleRight = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };
  const userData = useSelector((state) => state.userProfile?.userData);


  const visiblePages = 4;

  const renderPageNumbers = () => {
    const pageNumbers = [];
    let startPage = currentPage - Math.floor(visiblePages / 2);
    let endPage = currentPage + Math.floor(visiblePages / 2);

    if (startPage < 1) {
      startPage = 1;
      endPage = Math.min(totalPages, visiblePages);
    }

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, totalPages - visiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={i === currentPage ? "active" : ""}
          onClick={() => {
            setCurrentPage(i);
            setFilter("");
          }}
        >
          <Link to="#">{i}</Link>
        </li>
      );
    }

    return pageNumbers;
  };

  const handleDropDown = (value) => {
    setRecordLen(value);
    setRecordsPerPage(value);
    setCurrentPage(1);
  };

  // useEffect(() => {
  //   SetMyAssignments(myAssignmentsDetails);
  // }, [myAssignmentsDetails]);

  // Filter Data - Start
  const [inputValue, setInputValue] = useState("");
  const matchesSearchText = (assign) => {
    const searchText = inputValue.toLowerCase();
    if (assignmentTypeParam === "Cancelled") {
      return (
        format(new Date(assign.cnd_assignment_availability_date), "dd-MM-yyyy")
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_availability_date
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_availability_week_day?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_start_time?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_end_time?.toLowerCase()?.includes(searchText) ||
        assign.clt_company_name?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_name?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_cancel_reason
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_cancel_comment
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_work_shift_type
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_health_and__safety_implications
          ?.toLowerCase()
          ?.includes(searchText)
      );
    } else {
      return (
        format(new Date(assign.cnd_assignment_availability_date), "dd-MM-yyyy")
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_availability_date
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_availability_week_day?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_start_time?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_end_time?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_location?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_address1?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_address2?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_region?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_postal?.toLowerCase()?.includes(searchText) ||
        (assign.cnd_assignment_job_roles
          ? convertToOriginalForm(assign?.cnd_assignment_job_roles)
              ?.toLowerCase()
              ?.includes(searchText)
          : "") ||
        assign.clt_company_name?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_work_shift_type
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.pay_and_charge_pay_rate?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_health_and__safety_implications
          ?.toLowerCase()
          ?.includes(searchText)
      );
    }
  };

  const filterRows = myassignments
    ? myassignments.filter(matchesSearchText)
    : [];
 
    const prepareAssignmentsExportData = (data) => {
  if (!data || data.length === 0) return [];

  return data.map((assign, index) => ({
    "Sr.No.": index + 1,
    Date: format(
      new Date(assign.cnd_assignment_availability_date),
      "dd-MM-yyyy"
    ),
    Day: assign.cnd_availability_week_day || "-",
    Timing:
      assign.cnd_assignment_start_time +
      " - " +
      assign.cnd_assignment_end_time,
    "Client Name": assign.clt_company_name || "-",
    "Branch Name": assign.clt_branch_name || "-",
    Address: concateAddress(
      assign.clt_branch_address1,
      assign.clt_branch_address2,
      assign.clt_branch_town,
      assign.clt_branch_region,
      assign.clt_branch_postal
    ),
    "Job Title": assign.cnd_assignment_job_roles
      ? convertToOriginalForm(assign.cnd_assignment_job_roles)
      : "-",
    "Pay Rate": assign.pay_and_charge_pay_rate || "-",
    "Health & Safety":
      assign.cnd_assignment_health_and__safety_implications || "-",
  }));
};
const exportData = React.useMemo(() => {
  return prepareAssignmentsExportData(filterRows);
}, [filterRows]);

const handlePageChange = (page, pageSize = recordsPerPage) => {
  setCurrentPage(page);
  setRecordsPerPage(pageSize);
};
 const handleEyeClick = (destination) => {
    setSelectedDestination(destination);
    setIsModalOpen(true);
  };
    const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDestination("");
  };


useEffect(() => {
  if (userData) {
    const profileAddress = [
      userData.cnd_street_address,
      userData.cnd_street_address_2,
      userData.cnd_town,
      userData.cnd_region,
      userData.cnd_postcode,
    ]
      .filter(Boolean)
      .join(", ");

    setOriginAddress(profileAddress);
  }
}, [userData]);


console.log("USER DATA IN ASSIGNMENT:", props.userData);


  return (
    <React.Fragment>
     <div className="container mt-3">
       <div className="container mt-3">
  <div className="container">
    <div className="row align-items-center mb-3">

      {/* LEFT – Export Buttons */}
      <div className="col-sm-6 d-flex align-items-center">
        {/* <ExportButtons
          data={exportData}
          fileName="My_Assignments_List"
          buttons={true}
        /> */}
      </div>

      {/* RIGHT – Search */}
      <div className="col-sm-6 d-flex justify-content-end">
        <input
          type="text"
          name="search"
          className="form-control"
          placeholder="Search here"
          style={{ height: "40px", width: "200px" }}
          onChange={(event) => setInputValue(event.target.value)}

        />
      </div>

    </div>
  </div>
</div>

      <div
  className="courses-section"
  style={{
    maxHeight: "500px",
    overflowY: "auto",
    overflowX: "auto",
  }}
>

         <table className="courses-table">
            <thead className="text-white">
            <tr>
              {/*<th  className="col-1 text-center" scope="col">Sr. No</th>*/}
              <th className="col-2 text-center" >
                Date
              </th>
              <th className="col-3 text-center" >
                Timing
              </th>
              {/* <th  className="col-3 text-center" scope="col"> Name</th> */}
              {/*<th  className="col-2 text-center" scope="col">Email</th>*/}
              <th className="col-2 text-center" >
                Client Name
              </th>
              <th className="col-2 text-center" >
                Branch Name
              </th>
              {assignmentTypeParam === "Cancelled" ? (
                <>
                  <th className="col-2 text-center" >
                    Reason
                  </th>
                  <th className="col-2 text-center" >
                    Comment
                  </th>
                </>
              ) : (
                <>
                  <th className="col-2 text-center" >
                    Address
                  </th>
                  <th className="col-2 text-center" >
                    Job Title
                  </th>
                  <th className="col-2 text-center">
                    Pay Rate
                  </th>
                </>
              )}

              <th className="col-2 text-center" >
                Health & Safety Implications
              </th>

              {/* <th className="col-2 text-center" scope="col">
                Status
              </th> */}
              <th  className="col-1 text-center" scope="col">Direction</th>
            </tr>
          </thead>
          <tbody id="myTable">
            {filterRows &&
              filterRows.length > 0 &&
              filterRows?.slice(startIndex, endIndex).map((myassignment, i) => {
                if (i === 0) {
                  checkData = true;
                }
                return (
                  <tr key={i}>
                    {/*<td className="col-1 text-center" scope="row">
                    {i + 1}
              </td>*/}
                    <td className="col-2 text-center" >
                      {format(
                        new Date(myassignment.cnd_assignment_availability_date),
                        "dd-MM-yyyy"
                      ) +
                        " (" +
                        myassignment.cnd_availability_week_day
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ") +
                        ")"}
                    </td>
                    <td className="col-4 text-center">
                      {myassignment.cnd_assignment_start_time +
                        " - " +
                        myassignment.cnd_assignment_end_time}
                      <br />
                      {myassignment.cnd_assignment_work_shift_type === "regular"
                        ? "(Regular)"
                        : myassignment.cnd_assignment_work_shift_type}
                    </td>
                    <td className="col-2 text-center" >
                      {myassignment.clt_company_name
                        ? myassignment.clt_company_name
                        : "-"}
                    </td>
                    <td className="col-2 text-center" >
                      {myassignment.cnd_assignment_client_branch_id &&
                        myassignment.cnd_assignment_client_branch_id ===
                          myassignment.clt_branch_id && (
                          <>
                            {myassignment.clt_branch_location
                              ? myassignment.clt_branch_name
                              : myassignment.clt_branch_name
                                ? myassignment.clt_branch_name
                                : "-"}
                          </>
                        )}

                      {!myassignment.cnd_assignment_client_branch_id && (
                        <>
                          {myassignment.clt_service_town
                            ? myassignment.clt_company_name +
                              " - ( " +
                              myassignment.clt_service_town +
                              " )"
                            : myassignment.clt_company_name
                              ? myassignment.clt_company_name
                              : "-"}
                        </>
                      )}
                    </td>
                    {assignmentTypeParam === "Cancelled" ? (
                      <>
                        <td className="col-2 text-center" scope="row">
                          {myassignment.cnd_assignment_cancel_reason
                            ? myassignment.cnd_assignment_cancel_reason
                            : " - "}
                        </td>
                        <td className="col-2 text-center" scope="row">
                          {myassignment.cnd_assignment_cancel_comment
                            ? myassignment.cnd_assignment_cancel_comment
                            : " - "}
                        </td>
                      </>
                    ) : (
                      <>
                        <td
                          className="col-2 text-center cursor-pointer"
                          scope="row"
                          onClick={() =>
                            viewGlobalMapURL(
                              concateAddress(
                                myassignment.clt_branch_address1,
                                myassignment.clt_branch_address2,
                                myassignment.clt_branch_town,
                                myassignment.clt_branch_region,
                                myassignment.clt_branch_postal
                              )
                            )
                          }
                        >
                          {concateAddress(
                            myassignment.clt_branch_address1,
                            myassignment.clt_branch_address2,
                            myassignment.clt_branch_town,
                            myassignment.clt_branch_region,
                            myassignment.clt_branch_postal
                          )}
                        </td>
                        <td className="col-2 text-center" scope="row">
                          {myassignment.cnd_assignment_job_roles
                            ? convertToOriginalForm(
                                myassignment.cnd_assignment_job_roles
                              )
                            : " - "}
                        </td>
                        <td className="col-2 text-center" scope="row">
                          {myassignment.pay_and_charge_pay_rate
                            ? myassignment.pay_and_charge_pay_rate
                            : " - "}
                        </td>
                      </>
                    )}
                    <td className="col-2 text-center" scope="row">
                      {myassignment.cnd_assignment_health_and__safety_implications
                        ? myassignment.cnd_assignment_health_and__safety_implications
                        : " - "}
                    </td>
                   <td className="col-1 text-center">
                        <button
                          onClick={() =>
                            handleEyeClick(
                              concateAddress(
                                myassignment.clt_branch_address1,
                                myassignment.clt_branch_address2,
                                myassignment.clt_branch_town,
                                myassignment.clt_branch_region,
                                myassignment.clt_branch_postal
                              )
                            )
                          }
                          className="eye-icon-btn"
                          title="Open Direction"
                        >
                          <FaMapMarkerAlt size={20} />
                        </button>
                      </td>

                  </tr>
                );
              })}

              
            {filterRows && filterRows.length === 0 && (
              <tr className="text-center">
                <td colSpan="100">No Results Founds</td>
              </tr>
            )}

            <MapModal
  isOpen={isModalOpen}
  profileOrigin={originAddress}
  destination={selectedDestination}
  onClose={closeModal}
/>

          </tbody>
        </table>
        </div>
      </div>
      {filterRows && filterRows.length > 10 && (
       <TableNewPaginanation
    totalItems={filterRows.length}
    pageSize={recordsPerPage}
    currentPage={currentPage}
    onPageChange={handlePageChange}
    isDropdown={true}
    isPaggination={true}
  />
      )}
    </React.Fragment>
  );
};

export default MyAssignmentsList;
